import httpClient from '@/http-client'

export const viewData = (options = {}) => {
    return httpClient
        .get('/api/reports/driver-pickup-statistics', options)
        .then(response => Promise.resolve(response.data))
        .catch(error =>
            Promise.reject(error.response?.data || { message: error.message })
        )
}

export default { viewData }
